import * as React from "react";
import { BaseComponent } from "../base/BaseComponent";
export interface StarProps {
    starNo: number;
}
export class Star extends BaseComponent<StarProps, {}> {

    render() {
        let stars = [];
        let lop = 0;
        for (let i = 0; i < this.props.starNo; i++) {
            lop++;
            stars.push(<i key={`st-${lop}`} className="fa fa-star" style={{color: "orange"}} />);
        }
        for (let i = 0; i < 5 - this.props.starNo; i++) {
            lop++;
            stars.push(<i key={`st-${lop}`} className="fa fa-star-o" style={{opacity: 0.1}} />);
        }

        return (
            <span key={'hstars'}> {stars} </span>
        );
    }

}



// WEBPACK FOOTER //
// ./src/core/Star.tsx